import React from "react";
import { TFunction } from "i18next";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";

import { numberMatchWord } from "@constants/index";

import { ERROR_TEXT_STYLE } from "../constants";

type Props = {
    numberFidelityPoints: string;
    setNumberFidelityPoints: (v: string) => void;
    setInputNumberFidelityPoints: (v: boolean) => void;
    setIsEdited: (v: boolean) => void;
    isFidelityNumberInValid: boolean;
    inputNumberFidelityPoints: boolean;
    isFieldDisabled: boolean;
    isCentralizationActive: boolean;
    isConsultModalOpened: boolean;
    isConsult?: boolean;
    t: TFunction;
};

export default function FidelityPointsInput({
    numberFidelityPoints,
    setNumberFidelityPoints,
    setInputNumberFidelityPoints,
    setIsEdited,
    isFidelityNumberInValid,
    inputNumberFidelityPoints,
    isFieldDisabled,
    isCentralizationActive,
    isConsultModalOpened,
    isConsult,
    t,
}: Props) {
    return (
        <AvGroup className={isConsult ? "pe-none__clz" : ""}>
            <StyledLabel className="required__clz mt-3" htmlFor="name">
                {t("Number of fidelity points")}
            </StyledLabel>
            <StyledTextInput
                data-testid="fidelity-franchise-points-input"
                autoComplete="off"
                id="Number of fidelity points"
                name="Number of fidelity points"
                placeholder={t("Write")}
                type="text"
                className={classnames("fed_inp_FRnumberOfLoyaltyPoints", {
                    input__clz:
                        isFidelityNumberInValid || inputNumberFidelityPoints,
                    "not-allowed-icon__clz":
                        isFieldDisabled ||
                        (isCentralizationActive && isConsultModalOpened),
                })}
                onChange={(e: any) => {
                    setNumberFidelityPoints(e.target.value);
                    setIsEdited(true);
                    setInputNumberFidelityPoints(false);
                }}
                value={numberFidelityPoints}
                validate={{
                    pattern: {
                        value: numberMatchWord,
                        errorMessage: t(
                            "The number of fidelity points is invalid"
                        ),
                    },
                }}
            />
            {inputNumberFidelityPoints ? (
                <div style={ERROR_TEXT_STYLE}>
                    {t("Please enter a number of fidelity points")}
                </div>
            ) : null}
        </AvGroup>
    );
}
